// src/api/executive/performance.api.tsx
import BaseAPI from 'api/api'
import type {
  AppointmentsResponse,
  AvgBillPerVisitResponse,
  AvgRevenuePerPatientResponse,
  GetAppointmentDetailParams,
  GetAppointmentDetailResponse,
  GetAppointmentsParams,
  GetAvgBillPerVisitParams,
  GetAvgRevenuePerPatientParams,
  GetKeyProceduresDetailParams,
  GetKeyProceduresDetailResponse,
  GetKeyProceduresParams,
  GetPatientSummaryParams,
  GetPerBranchRevenueParams,
  GetPerBranchRevenueResponse,
  GetRevenueParams,
  KeyProceduresResponse,
  PatientSummaryResponse,
  RevenueSummaryResponse,
  RevenueTrendResponse,
} from './executive.types'

const path = 'executive/performance'

export default class PerformanceApi extends BaseAPI {
  static async getRevenueSummary(params: GetRevenueParams): Promise<RevenueSummaryResponse> {
    const res = await BaseAPI.api.get(`${path}/revenue`, { params })
    return res.data
  }

  static async getRevenueTrend(params: GetRevenueParams): Promise<RevenueTrendResponse> {
    const res = await BaseAPI.api.get(`${path}/revenue`, { params })
    return res.data
  }

  static async getPerBranchRevenue(
    params: GetPerBranchRevenueParams
  ): Promise<GetPerBranchRevenueResponse> {
    const res = await BaseAPI.api.get(`${path}/per-branch-revenue`, { params })
    return res.data
  }

  static async getKeyProcedures(params: GetKeyProceduresParams): Promise<KeyProceduresResponse> {
    const res = await BaseAPI.api.get(`${path}/key-procedures`, { params })
    return res.data
  }

  static async getPatientSummary(params: GetPatientSummaryParams): Promise<PatientSummaryResponse> {
    const res = await BaseAPI.api.get(`${path}/patient-summary`, { params })
    return res.data
  }

  static async getAvgBillPerVisit(params: GetAvgBillPerVisitParams): Promise<AvgBillPerVisitResponse> {
    const res = await BaseAPI.api.get(`${path}/avg-bill-per-visit`, { params })
    return res.data
  }

  static async getAvgRevenuePerPatient(
    params: GetAvgRevenuePerPatientParams
  ): Promise<AvgRevenuePerPatientResponse> {
    const res = await BaseAPI.api.get(`${path}/avg-revenue-per-patient`, { params })
    return res.data
  }

  static async getAppointments(params: GetAppointmentsParams): Promise<AppointmentsResponse> {
    const res = await BaseAPI.api.get(`${path}/appointments`, { params })
    return res.data
  }

  static async getAppointmentDetail(
    params: GetAppointmentDetailParams
  ): Promise<GetAppointmentDetailResponse> {
    const res = await BaseAPI.api.get(`${path}/appointment-detail`, { params })
    return res.data
  }

  static async getKeyProceduresDetail(
    params: GetKeyProceduresDetailParams
  ): Promise<GetKeyProceduresDetailResponse> {
    const res = await BaseAPI.api.get(`${path}/key-procedures-detail`, { params })
    return res.data
  }
}
